import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_stacktrace/values/$id/_layout/methods/')({});